import apiClient from '../apiClient'

const dialCreator = async (creatorId, callType) => {
    const response = await apiClient.post('/dial/creator', {
        creatorId,
        callType,
    })
    return response.data
}

const rejectDial = async (orderId) => {
    try {
        const response = await apiClient.post(`/dial/reject/${orderId}`)
        return response.data
    } catch (error) {
        console.log('Failed to reject dial: ' + error.message)
        return null
    }
}

const cancelDial = async (orderId) => {
    try {
        const response = await apiClient.post(`/dial/cancel/${orderId}`, {
            reason: 'I changed my mind',
        })
        return response.data
    } catch (error) {
        console.log('Failed to cancel dial: ' + error.message)
        return null
    }
}

const acceptDial = async (orderId, socketId) => {
    try {
        const response = await apiClient.post(`/dial/accept/${orderId}`, {
            socketId,
        })
        return response.data
    } catch (error) {
        console.log('Failed to accept dial: ' + error.message)
        return null
    }
}

const endCall = async (callSessionId) => {
    try {
        const response = await apiClient.post(`/dial/end/${callSessionId}`)
        return response.data
    } catch (error) {
        console.log('Failed to end call: ' + error.message)
        return null
    }
}

const getPendingCalls = async () => {
    try {
        const response = await apiClient.get('/dial/pending')
        return response.data
    } catch (error) {
        console.log('Failed to get pending calls: ' + error.message)
        return null
    }
}

export default {
    dialCreator,
    rejectDial,
    cancelDial,
    acceptDial,
    endCall,
    getPendingCalls,
}
